import {
  Edit,
  ListButton,
  minValue,
  NumberInput,
  required,
  SaveButton,
  SelectInput,
  ShowButton,
  SimpleForm,
  TextInput,
  Toolbar,
  TopToolbar,
} from "react-admin";

import { ClientAppInput } from "@/modules/clientApps";
import { PaymentProviderInput } from "@/modules/paymentProviderModel";

import { BILLING_STRATEGY_CHOICES } from "./constants";

const EditToolbar = () => (
  <Toolbar sx={{ gap: 2 }}>
    <SaveButton label="Update" />
    <ShowButton label="Cancel" icon={null} variant="outlined" size="medium" />
  </Toolbar>
);

const EditActions = () => (
  <TopToolbar sx={{ justifyContent: "space-between" }}>
    <ListButton />
    <ShowButton />
  </TopToolbar>
);

export const TariffEdit = () => (
  <Edit actions={<EditActions />} mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />}>
      <TextInput source="id" disabled />
      <TextInput source="createdAt" disabled />
      <TextInput source="updatedAt" disabled />
      <TextInput source="productId" label="Product Id" />
      <NumberInput source="price" validate={[minValue(0)]} />
      <TextInput source="publicKey" />
      <SelectInput
        source="billingStrategy"
        validate={required()}
        choices={BILLING_STRATEGY_CHOICES}
      />
      <ClientAppInput
        label="Client App"
        source="clientApp.@id"
        optionValue="@id"
      />
      <PaymentProviderInput source="paymentProviderId" />
      <NumberInput source="refCommission" validate={[minValue(0)]} />
    </SimpleForm>
  </Edit>
);
